import { CallTagsSettings } from '@/components/call-tags';
import { SettingsSectionHeader } from '@/components/settings/section-header';
import { Layout } from '@/components/ui/design-system';
import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/call-tags/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');

  return (
    <Layout isScrollable contentClassName="max-w-[960px] px-20 !pt-0 pb-30">
      <section className="flex flex-col gap-4">
        <SettingsSectionHeader
          title={t('settings.sidebar.callTags', 'Call tags')}
          description={t(
            'numbers.callTags.description',
            "Tags are global to all your team's numbers",
          )}
        />
        <CallTagsSettings />
      </section>
    </Layout>
  );
}
